<template>
  <v-card class="betDetails mb-2">
    <v-btn v-if="isDeveloper" color="white"
      icon elevation="0" class="ml-2" fab small style="float: right"
      @click="toggleAccessModal">
      <v-icon dark>
        mdi-incognito
      </v-icon>
    </v-btn>
    <v-btn icon elevation="0" color="white" class="ml-2" fab small
      style="float: right">
      <v-icon dark>
        mdi-account
      </v-icon>
    </v-btn>
    <v-btn icon elevation="0" color="white" class="ml-2" fab small
      style="float: right"
      @click=logout>
      <v-icon dark>
        mdi-export
      </v-icon>
    </v-btn>
    <div>
      <v-tooltip v-if="!$vuetify.theme.dark" bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="mt-1 ml-4" v-on="on" color="info" x-small fab @click="darkMode">
            <v-icon>mdi-moon-waxing-crescent</v-icon>
          </v-btn>
        </template>
        <span>Dark Mode On</span>
      </v-tooltip>

      <v-tooltip v-else bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="mt-1 ml-4" v-on="on" color="info" x-small fab @click="darkMode">
            <v-icon color="yellow">mdi-white-balance-sunny</v-icon>
          </v-btn>
        </template>
        <span>Dark Mode Off</span>
      </v-tooltip>
    </div>
    <div class="dashboard-headerMenu">
      <BookieColumn :bookiesrace="bookiesrace" :items="items" :viewType="viewType" :updateDataTableHeight="updateDataTableHeight"/>
    </div>
  </v-card>
</template>

<script>
import numeral from 'numeral'
import { format } from 'date-fns'
import BookieColumn from '../BookieColumn'

export default {
  name: 'BookieList',
  data () {
    return {
      numeral,
      format
    }
  },
  components: {
    BookieColumn
  },
  props: {
    race: {
      type: Object,
      default: () => {}
    },
    meeting: {
      type: Object,
      default: () => {}
    },
    items: {
      type: Array,
      default: () => []
    },
    bookiesrace: {
      type: Array,
      default: () => []
    },
    isDeveloper: {
      type: Boolean
    },
    darkMode: {
      type: Function
    },
    toggleAccessModal: {
      type: Function
    },
    logout: {
      type: Function
    },
    viewType: {
      type: String
    },
    updateDataTableHeight: {
      type: Function
    }
  }
}
</script>

<style scoped>
  .betsText {
    grid-area: text;
  }
  .betsButtons {
    margin-left: auto;
    margin-right: 0;
    grid-area: buttons;
  }
  .betsButtonsGrid {
    display: grid;
    grid-template-columns: auto;
    grid-template-areas:
      "text buttons";
  }
  .betDetails {
    height: 100vh;
    border-radius: 0 !important;
    background-color: rgb(67, 80, 88);
  }
  .betDetails_header {
    height: 100%;
    color: white;
    background-color: #333;
    display: flex;
    align-items: center;
    padding:4px 8px 4px 8px;
  }
  .betDetails_header span {
    margin-right: 5px;
  }
  .betDetails-content {
    padding: 4px 0px 0px 8px;
    font-size:15px;
  }
</style>
